// FRONTEND/sr/component/counselling/Mbprecounselling.jsx


import React, {useState, useEffect} from "react";

import {Row, Col, Table, Container} from "react-bootstrap";

export const Mbprecounselling = () => {

    //Hooks




return(

    <Container fluid>

        Hello

    </Container>
)

}